/**
 * Configuration for organizations in this app.
 */
const jobiqoCompanyConfig = require('./../src/jobiqo/config/organizations');
const R = require('ramda');
const { geoFixtures } = require('./fixtures');

module.exports = R.mergeDeepRight(jobiqoCompanyConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    SHOW_ONLY_FEATURED_ORGANIZATIONS: true,
    GEO_INFO: {
      fixtures: geoFixtures,
      radius: {
        options: [5, 10, 30, 60, 100],
        defaultValue: 30,
        unit: 'miles',
        unitMultiplier: 1,
        hideForLocationType: ['country', 'administrative_area_level_1'],
      },
    },
    CUSTOMER_PROFILE_FIELDS: {
      info: {
        fields: {
          field_customer_vat_number: false,
        },
      },
    },
  },
});
